var __filename="/ui/derbyPassportCustom/index.js";var config;

config = {
  ns: "derby-passport-custom",
  filename: __filename,
  scripts: {
    register: require("./register/index.js"),
    login: require("./login/index.js"),
    changePassword: require("./changePassword/index.js"),
    forgotPassword: require("./forgotPassword/index.js") //mhb moved from login
  }
};

module.exports = function(app, options) {
  return app.createLibrary(config, options);
};
